<template>
<div class="show">
  <el-dialog :title="title" :visible.sync="show"  @close="compClose" :modal-append-to-body='false' :width="width">
   <iframe v-if="title !='监控'" :src="dataUrl" frameborder="0" width="100%" height="700"></iframe>
   <div v-else style="height:80%;">
    <el-container style="height: 550px; border: 1px solid #eee">
          <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
            <el-menu @open="handleOpen">
              <!-- <el-menu-item v-for="key in menuList" :index="key.indexCode">{{key.name}}</el-menu-item> -->
              <el-submenu v-for="key in menuList" :key="key.indexCode" :index="key.indexCode">
                <template slot="title">
                  <i class="el-icon-menu"></i>
                  <span slot="title">{{key.name}}</span>
                </template>
                <el-menu-item v-for="its in key.child" :key="its.indexCode" :index="its.indexCode" @click.native.shop="hanglejk(its.indexCode)">{{its.name}}</el-menu-item>
              </el-submenu>
            </el-menu>
          </el-aside>
          
          <el-container>
            <el-main style="position: relative;">
              <div style="z-index: 1;position: absolute;left:0;right:0;top:0;bottom: 0;"></div>
              <right-bottom v-if="luxiang.length>0" :dataVal="luxiang" ></right-bottom>
            </el-main>
          </el-container>
        </el-container>  
   </div>
  </el-dialog>
</div>
</template>

<script>
import {hik_getRegions,hik_cameraSearch,hik_camerasPreviewURLs } from '../../network/api/home'
import RightBottom from "./jiankong.vue";
export default {
  name: "comp-table",
  components: {
			RightBottom,
		},
  data() {
    return {
      width: '80%',
      luxiang: '',
      tabs: [],
      menuList: [],
      activeName: '',
      loading: true,
      formInline: {
        selValue: '',
        region: ''
      },
      selData: [],
      selValue: '',
      show:this.visible,
      gridData: [],
      params: {}
    }
  },

  props: {
    title: {
      type:String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false,
    },
    tableData: {
      type:Array,
      default: ()=> {}
    },
    dataParams: {
      type:Object,
      default: ()=> {}
    },
    dataUrl: {
      type:String,
      default: ''
    }
  },

  watch: {
    visible: {
      handler(newVal,oldVal) {
        this.show = newVal
        if(newVal == true) {
          setTimeout(() => {
            this.loading = false
          },500)
          if(this.title == '监控') {
            this.width = '60%'
            this.getInfo()
          }
          console.log(this.title,'###################')
        
        } else {
          this.loading = true
        }

      }
    },
    activeName: {
      handler(newVal,oldVal) {
        this.hangleInit()
      },
      immediate: true,
		  deep: true
    }
  },

  mounted() {
   
  },


  methods: {
    hangleInit() {
      // if(this.activeName != 0) {
      //   hik_cameraSearch({regionlndexCodes: this.activeName,pageNo:1,pageSize: 100}).then(res => {
      //     this.menuList = res.data.data.list
      //   console.log(res,'SFFFzhe则会使')
      //   })
      // }
      
    },
    handleOpen(key, keyPath) {
        console.log(key, keyPath);
      },
      hanglejk(e) {
        console.log(e,'&^^^^^^^^^^^^^^^^^^^^^^^^^^^');
        hik_camerasPreviewURLs({indexCode:e,pageNo:1,pageSize: 1,protocol:'ws'}).then(item => {
          this.luxiang = item.data.data.url
        })
      },
    async getInfo() {
      let res1 = await hik_getRegions({pageNo:1,pageSize: 100})
      if(res1.code == 0 && res1.data.data.list.length>0) {
        let bh = []
        res1.data.data.list.forEach(item => {
						bh.push(item.indexCode)
					})
        let res2 = await hik_cameraSearch({regionlndexCodes:bh.join(','),pageNo:1,pageSize: 300})
        if(res2.code == 0) {
            res2.data.data.list.forEach((info2,index) => {
              res1.data.data.list.forEach(info1 => {
                if(info1.indexCode == info2.regionIndexCode) {
                  if(!info1.child) { info1.child = [] }
                  info1.child.push(info2)
                }
              })
              
								// this.RightCenterData.
									// console.log(info,'25点00分+++++++++++++++++++++++++++++++++++++++++++++')
									// if(index == 0) {
									// 	hik_camerasPreviewURLs({indexCode:info.indexCode,pageNo:1,pageSize: 100,protocol:'ws'}).then(item => {
									// 		console.log(item,'15点00分'+ (index+1))
									// 		this.luxiang = item.data.data.url
									// 	})
									// }
								
								
							})
						}
            this.menuList = res1.data.data.list
            console.log(res1.data.data.list,'&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&')
       }
    },
    handleClick(tab, event) {
        console.log(tab, event);
        // this.hangleInit()
      },
    clickSearch() {
      if(this.selValue) {
        if(this.title == '管理费用') {
          this.params = {
            costId: this.selValue
          }
        } else if(this.title == '企业经营趋势') {
          this.params = {
            quarterId: this.selValue
          }
        } else {
          this.params.deptId = this.selValue
        }

      }
      // this.getData()
      this.getData('net')
    },
    clickReSearch() {
      this.selValue = ''
      this.params = {}
      // this.getData()
      this.getData('net')
    },
    getParam(name){
      var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if(r!=null)return  unescape(r[2]); return null;
    },
    getData(net) {
      let sid = this.getParam('sid');
      if(net) {
        currentGET("test", {...this.dataParams, ...this.params,sid:sid,cmd:"com.tyersoft.apps.bussiness.plan."+this.dataUrl}).then((res) => {
          if (res.result == 'ok') {
            this.gridData =res.data
          } else {
            this.$Message({
              text: res.msg,
              type: "warning",
            });
          }
        });
      } else {
        currentGET(this.dataUrl, {...this.dataParams, ...this.params}).then((res) => {
          if (res.result == 'ok') {
            this.gridData =res.data
          } else {
            this.$Message({
              text: res.msg,
              type: "warning",
            });
          }
        });
      }


    },
    getSiji(net) {
      let sid = this.getParam('sid');
      if(net) {
        currentGET("test", {sid:sid,cmd:"com.tyersoft.apps.bussiness.plan.manage_getQuarterData"}).then((res) => {
          if (res.result == 'ok') {
            this.selData =res.data
          } else {
            this.$Message({
              text: res.msg,
              type: "warning",
            });
          }
        });
      } else {
        currentGET('manage_getQuarterData').then((res) => {
          if (res.result == 'ok') {
            this.selData =res.data
          } else {
            this.$Message({
              text: res.msg,
              type: "warning",
            });
          }
        });
      }
    },
    getPrice(net) {
      let sid = this.getParam('sid');
      if(net) {
        currentGET("test", {sid:sid,cmd:"com.tyersoft.apps.bussiness.plan.manage_getCostAccountData"}).then((res) => {
          if (res.result == 'ok') {
            this.selData =res.data
          } else {
            this.$Message({
              text: res.msg,
              type: "warning",
            });
          }
        });
      } else {
        currentGET('manage_getCostAccountData').then((res) => {
          if (res.result == 'ok') {
            this.selData =res.data
          } else {
            this.$Message({
              text: res.msg,
              type: "warning",
            });
          }
        });
      }
    },
    getType(net) {
      let sid = this.getParam('sid');
      if(net) {
        currentGET("test", {sid:sid,cmd:"com.tyersoft.apps.bussiness.plan.manage_getAllDept"}).then((res) => {
          if (res.result == 'ok') {
            this.selData =res.data
          } else {
            this.$Message({
              text: res.msg,
              type: "warning",
            });
          }
        });
      } else {
        currentGET('manage_getAllDept').then((res) => {
          if (res.result == 'ok') {
            this.selData =res.data
          } else {
            this.$Message({
              text: res.msg,
              type: "warning",
            });
          }
        });
      }


    },
    tableRowClassName({row, rowIndex}) {
      if(rowIndex % 2 != 1) {
        return 'tab--tr-color1'
      }else {
        return 'tab--tr-color2'
      }
    },
    compClose() {
      this.show = false
      this.$emit("close")
    }
  }

}
</script>

<style scoped>
.show {
  /* opacity: 1;
	transition-duration: 0.3s;
	-ms-transform: scale(1);
	transform: scale(1);
	overflow-x: hidden;
	overflow-y: auto;
	pointer-events: auto; */
}

::v-deep .v-modal {
 
 opacity: .8;

 background: rgb(0, 0, 0);

}

::v-deep .el-tabs__header {
  margin: 0;
}
::v-deep .el-tabs__item.is-active {
  color: #fff;
}
::v-deep .el-tabs__item {
  color: #777;
}
.el-table__empty-block {
  background: #1A5CD7;
}
::v-deep .el-table__body-wrapper {
  background: #0b1f4b;
  color: #fff;
}
::v-deep .el-tabs__item.is-active {
  color: #1A5CD7;
}
</style>